import { render, staticRenderFns } from "./EditBoxTemplates.vue?vue&type=template&id=964304f8"
import script from "./EditBoxTemplates.vue?vue&type=script&lang=js"
export * from "./EditBoxTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports